import {
  styled,
  Box,
  BoxProps,
  Typography,
  css,
  TypographyProps
} from '@mui/material'

interface IProductOptionsRowProps extends BoxProps {
  hideCounter?: boolean
}

export const ProductOptionsContainer = styled(Box)<BoxProps>(
  () => css`
    width: 100%;
    padding: 5px 0;
  `
)

export const ProductOptionsRow = styled(Box)<IProductOptionsRowProps>(
  ({ theme, hideCounter }) => css`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    .Counter {
      max-width: 120px;
    }
    border-bottom-width: 1px;
    border-bottom-color: ${theme.palette.background.default};
    border-bottom-style: solid;
    .MuiFormGroup-root {
      width: 100%;
    }
    label {
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }
    .overlay {
      display: none;
      ${hideCounter &&
      css`
        display: initial;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: ${theme.palette.grey[400]};
        opacity: 0.5;
        z-index: 1;
      `}
    }
    .text-on-disabled {
      margin-right: 10px;
    }
  `
)

export const ProductsOptionsHeader = styled(Box)<BoxProps>(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    background-color: ${theme.palette.background.default};
    padding: 16px 12px;
    .header-texts {
      font-size: 10px;
      font-weight: 600;
    }
    .header-texts:first-child {
      text-transform: uppercase;
      color: ${theme.palette.grey[600]};
    }
  `
)

export const Label = styled(Typography)<TypographyProps>`
  font-weight: 600;
  font-size: 12px;
  padding-left: 12px;
`
